export default __webpack_public_path__ + "static/media/icon-email.b3e05daa.svg";